export enum ClientExtractLoanPartGuaranteeEnum {
  NHG = 'NHG',
  Communal = 'Communal',
  VAT = 'VAT',
  Na = 'Na',
  Unknown = 'Unknown',
}
